//
// Module for the Manual wizard's Benefit Details step
//
rs.module("participant/benefit/setup/manual/wizard/benefitdetailsstep",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, defaultValues) {

            // get JS selectors
            var instructionsCard = $.js(jsSelectors.instructionsCard);

            var paymentAddressType = instructionsCard.js(jsSelectors.paymentAddressType);
            var paymentContactType = instructionsCard.js(jsSelectors.paymentContactType);
            var _1099AddressType = instructionsCard.js(jsSelectors._1099AddressType);
            var _1099ContactType = instructionsCard.js(jsSelectors._1099ContactType);

            var taxInformationCard = $.js(jsSelectors.taxInformationCard);

            var taxFreeCalcMethodSelect = taxInformationCard.js(jsSelectors.taxFreeCalcMethodSelect);
            var taxFreeAmountContainer = taxInformationCard.js(jsSelectors.taxFreeAmountContainer);
            var taxFreeAmountInput = taxFreeAmountContainer.js(jsSelectors.taxFreeAmountInput);
            var taxFreeAmountHidden = taxFreeAmountContainer.js(jsSelectors.taxFreeAmountHidden);

            // initialize select helpers
            var paymentAddressTypeSelectHelper = selectHelper.getHelper(paymentAddressType);
            var paymentContactTypeSelectHelper = selectHelper.getHelper(paymentContactType);
            var _1099AddressTypeSelectHelper = selectHelper.getHelper(_1099AddressType);
            var _1099ContactTypeSelectHelper = selectHelper.getHelper(_1099ContactType);

            // Hookup taxFreeCalcMethodSelect change event
            taxFreeCalcMethodSelect.change(enableDisableTaxFields);

            // Enable or disable Tax Amount/Percent inputs based on selected Tax Free Calc Method
            function enableDisableTaxFields() {

                var selectedTaxFreeCalcMethod = taxFreeCalcMethodSelect.val();

                if (selectedTaxFreeCalcMethod == codeValues.simplified) {
                    taxFreeAmountContainer.show();
                    taxFreeAmountInput.prop("disabled", true).val(defaultValues.taxFreeAmount).clearErrors();
                    taxFreeAmountHidden.val(defaultValues.taxFreeAmount);
                } else if (selectedTaxFreeCalcMethod == codeValues.userInput) {
                    taxFreeAmountContainer.show();
                    taxFreeAmountInput.prop("disabled", false).val("$0.00").clearErrors();
                    taxFreeAmountHidden.val("");
                } else {
                    taxFreeAmountContainer.hide();
                    taxFreeAmountInput.val("").clearErrors();
                    taxFreeAmountHidden.val("");
                }
            }

            // payment address type change handler - clear payment contact type
            paymentAddressType.change(function () {
                paymentContactTypeSelectHelper.setValue(null);
            });

            // payment contact type change handler - clear payment address type
            paymentContactType.change(function () {
                paymentAddressTypeSelectHelper.setValue(null);
            });

            // 1099 address type change handler - clear 1099 contact type
            _1099AddressType.change(function () {
                _1099ContactTypeSelectHelper.setValue(null);
            });

            // 1099 contact type change handler - clear 1099 address type
            _1099ContactType.change(function () {
                _1099AddressTypeSelectHelper.setValue(null);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);